"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoVerificationAttemptDetailDto = exports.PhotoVerificationAttemptListItemDto = exports.PhotoVerificationVisionResultDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
/** Snapshot of Google Vision gates stored with each verification attempt. */
class PhotoVerificationVisionResultDto {}
exports.PhotoVerificationVisionResultDto = PhotoVerificationVisionResultDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], PhotoVerificationVisionResultDto.prototype, "hasPerson", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], PhotoVerificationVisionResultDto.prototype, "hasQualifyingFace", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String]
}), __metadata("design:type", Array)], PhotoVerificationVisionResultDto.prototype, "faceQualityIssues", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], PhotoVerificationVisionResultDto.prototype, "isAdultContentAbsent", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], PhotoVerificationVisionResultDto.prototype, "adult", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], PhotoVerificationVisionResultDto.prototype, "isLikelyMinor", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: [String]
}), __metadata("design:type", Array)], PhotoVerificationVisionResultDto.prototype, "minorLabels", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: 'array',
  items: {
    type: 'object',
    properties: {
      name: {
        type: 'string'
      },
      score: {
        type: 'number'
      }
    }
  }
}), __metadata("design:type", Array)], PhotoVerificationVisionResultDto.prototype, "persons", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], PhotoVerificationVisionResultDto.prototype, "passed", void 0);
class PhotoVerificationAttemptListItemDto {}
exports.PhotoVerificationAttemptListItemDto = PhotoVerificationAttemptListItemDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], PhotoVerificationAttemptListItemDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.PhotoVerificationContext
}), __metadata("design:type", String)], PhotoVerificationAttemptListItemDto.prototype, "context", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], PhotoVerificationAttemptListItemDto.prototype, "passed", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], PhotoVerificationAttemptListItemDto.prototype, "failureErrorCode", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], PhotoVerificationAttemptListItemDto.prototype, "userPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], PhotoVerificationAttemptListItemDto.prototype, "accountPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], PhotoVerificationAttemptListItemDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], PhotoVerificationAttemptListItemDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], PhotoVerificationAttemptListItemDto.prototype, "email", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false,
  description: 'Current avatar URL when this attempt still matches the account photo; otherwise null.'
}), __metadata("design:type", Object)], PhotoVerificationAttemptListItemDto.prototype, "currentImageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether the attempt image hash matches the user’s current avatar.'
}), __metadata("design:type", Boolean)], PhotoVerificationAttemptListItemDto.prototype, "isCurrentAvatar", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether an admin can manually mark this photo as verified.'
}), __metadata("design:type", Boolean)], PhotoVerificationAttemptListItemDto.prototype, "canManuallyVerify", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], PhotoVerificationAttemptListItemDto.prototype, "userIsPhotoVerified", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], PhotoVerificationAttemptListItemDto.prototype, "manuallyVerifiedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], PhotoVerificationAttemptListItemDto.prototype, "createdAt", void 0);
class PhotoVerificationAttemptDetailDto extends PhotoVerificationAttemptListItemDto {}
exports.PhotoVerificationAttemptDetailDto = PhotoVerificationAttemptDetailDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], PhotoVerificationAttemptDetailDto.prototype, "imageHash", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: PhotoVerificationVisionResultDto
}), __metadata("design:type", PhotoVerificationVisionResultDto)], PhotoVerificationAttemptDetailDto.prototype, "visionResult", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  required: false
}), __metadata("design:type", Object)], PhotoVerificationAttemptDetailDto.prototype, "manuallyVerifiedByEmail", void 0);
//# sourceMappingURL=PhotoVerificationAttempt.dto.js.map